import React from "react";

export default function ModalScrollArea({ children, id }) {
  return (
    <div
      className="modal-scroll-area"
      id={id}
      role="region"
      aria-label="Inquiry form"
      tabIndex={0}
    >
      {children}
    </div>
  );
}
